import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentFluidCapacity, ListItem, RepositoryModal } from '../../shared'
import { FluidCapacityListComponent } from './fluid-capacity-list.component'

@Component({
    templateUrl: './fluid-capacity-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class FluidCapacityModalComponent extends RepositoryModal<EquipmentFluidCapacity> {
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        const parent = this.editOptions.initializeParams as FluidCapacityListComponent
        this.equipmentOptions = parent.equipmentOptions
    }

    protected onBeforeSave(): boolean {
        this.target.compartment = (this.editOptions.initializeParams as FluidCapacityListComponent).compartment
        return true
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                ;(this.editOptions.initializeParams as FluidCapacityListComponent).parent.refresh()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
